export const translations = {
    id: {
        // NAVBAR
        nav_home: "Beranda",
        nav_villas: "Villa",
        nav_contact: "Hubungi Kami",

        // HERO / LANDINGPAGE
        hero_title: "Temukan Villa Impianmu",
        hero_subtitle: "Rasakan keindahan Jogja dengan kenyamanan dan kemewahan",
        search_location: "Lokasi",
        search_location_placeholder: "Masukkan lokasi",
        search_checkin: "Check-in",
        search_checkout: "Check-out",
        search_guests: "Jumlah Tamu",
        search_beds: "Kamar",
        search_beds_all: "Semua",
        search_btn: "Cari",

        // GUEST OPTIONS
        guest_2: "2 Orang",
        guest_3: "3 Orang",
        guest_4: "4 Orang",
        guest_5: "5 Orang",
        guest_6: "6 Orang",
        guest_7: "7 Orang",
        guest_8: "8 Orang",
        guest_9: "9 Orang",
        guest_10: "10 Orang",
        guest_11: "11 Orang",
        guest_12: "12 Orang",
        guest_13: "13 Orang",
        guest_14: "14 Orang",
        guest_15: "15 Orang",
        guest_15plus: "> 15 Orang",
        guest_20plus: "> 20 Orang",

        // STATS
        stat_villas: "Villa Premium",
        stat_guests: "Tamu Bahagia",
        stat_rating: "Rating Rata-rata",
        stat_support: "Dukungan",

        // HOW IT WORKS
        how_title: "Cara Pemesanan",
        how_subtitle: "Pesan villa impianmu hanya dalam beberapa langkah mudah",
        how_step1_title: "Cari Villa",
        how_step1_desc: "Temukan villa sesuai lokasi dan jumlah tamu",
        how_step2_title: "Pilih Tanggal",
        how_step2_desc: "Tentukan tanggal check-in dan check-out dengan mudah",
        how_step3_title: "Lakukan Pembayaran",
        how_step3_desc: "Pembayaran aman dengan berbagai metode",
        how_step4_title: "Nikmati Liburan",
        how_step4_desc: "Check-in dan nikmati pengalaman menginap terbaik",

        // WHY US
        why_title: "Mengapa Memilih JogjaVilla?",
        why_1_title: "Terpercaya & Aman",
        why_1_desc: "Semua villa kami terverifikasi dan terjamin keamanannya",
        why_2_title: "Lokasi Terbaik",
        why_2_desc: "Lokasi strategis di Jogja dengan pemandangan indah",
        why_3_title: "Pemesanan Mudah",
        why_3_desc: "Proses booking sederhana dan cepat, konfirmasi dalam menit",

        // FEATURED VILLAS
        featured_title: "Villa Unggulan",
        featured_subtitle: "Villa pilihan terbaik untuk liburan sempurna Anda",
        view_all: "Lihat Semua Villa",
        per_night: "per malam",
        book_now: "Pesan Sekarang",

        // TESTIMONIALS
        testimonial_title: "Apa Kata Mereka?",
        testimonial_sub: "Pengalaman nyata dari pelanggan kami",

        // RECENTLY VIEWED
        recently_viewed: "Baru Dilihat",
        clear_history: "Hapus Riwayat",

        // CTA
        cta_title: "Siap Memulai Perjalanan Anda?",
        cta_desc: "Jelajahi koleksi villa dan homestay indah kami di Jogja. Pesan sekarang dan ciptakan kenangan tak terlupakan!",
        cta_btn: "Jelajahi Semua Villa",

        // VILLAS PAGE
        villas_hero_title: "Eksplorasi Penginapan Terbaik",
        villas_hero_sub: "Temukan ketenangan di setiap sudut Yogyakarta",
        villas_search_placeholder: "Cari nama villa atau lokasi...",
        filter_capacity: "Kapasitas Tamu",
        filter_sort: "Urutkan: Terbaik",
        sort_low: "Harga Terendah",
        sort_high: "Harga Tertinggi",
        no_results_title: "Maaf, Villa tidak ditemukan",
        no_results_desc: "Coba ubah kata kunci atau filter Anda.",
        reset_filter: "Reset Filter",
        tamu: "Tamu",
        bed: "Kasur",
        bath: "Kamar Mandi",
        price_varies: "Harga bervariasi",
        check_price: "Cek Harga →",

        // VILLA DETAIL
        back_to_list: "Kembali ke Daftar",
        choose_room: "Pilih Variasi Unit",
        choose_room_desc: "Silakan klik salah satu variasi unit di bawah ini untuk melihat detail spesifik dan harga check-out:",
        no_rooms: "Tidak ada variasi kamar tambahan untuk properti ini.",
        selected_label: "🌟 (Dipilih)",
        capacity_title: "Kapasitas Penginapan",
        capacity_peserta: "Kapasitas Peserta",
        capacity_kamar: "Jumlah Kamar",
        capacity_bed_type: "Tipe Kamar / Bed",
        bed_main: "Ukuran bed utama:",
        bathroom_title: "Detail Kamar Mandi",
        bathroom_count: "Jumlah Kamar Mandi",
        bathroom_type: "Tipe Kamar Mandi",
        about_villa: "Tentang Villa Ini",
        facilities_title: "Fasilitas & Layanan",
        facilities: "Fasilitas",
        equipment: "Perlengkapan",
        amenities: "Amenities",
        hours_title: "Jam Operasional / Aturan",
        no_smoking: "🚭 Dilarang merokok di dalam",
        no_pets: "🐾 Tidak diperbolehkan membawa hewan",
        book_card_title: "Pesan Sekarang",
        price_per_night: "/ malam",
        btn_booking: "Lanjutkan Pemesanan",
        btn_whatsapp: "Tanya via WhatsApp",
        reviews: "ulasan",

        // BOOKING PAGE
        back_booking: "← Kembali ke Detail Villa",
        booking_title: "Lengkapi Pemesanan Anda",
        booking_details: "Detail Pemesanan",
        checkin_label: "Check-in",
        checkout_label: "Check-out",
        guests_label: "Jumlah Tamu",
        contact_info: "Informasi Kontak",
        fullname_label: "Nama Lengkap",
        fullname_placeholder: "Nama lengkap",
        whatsapp_label: "Nomor WhatsApp",
        btn_continue: "Lanjutkan ke Pembayaran",
        processing: "Memproses...",
        booking_summary: "Ringkasan Pemesanan",
        price_per_night_summary: "Harga / Malam",
        duration: "Durasi",
        nights: "malam",
        total: "Total",

        // PAYMENT PAGE
        back_payment: "← Kembali ke Booking",
        payment_title: "Pembayaran",
        select_method: "Pilih Metode Pembayaran",
        select_type: "Pilih Tipe Pembayaran",
        payment_instructions: "Instruksi Pembayaran",
        how_to_pay: "Cara Pembayaran:",
        step1: "Transfer sesuai nominal",
        step2: "Simpan bukti pembayaran",
        step3: "Klik \"Konfirmasi Pembayaran\"",
        agree_terms: "Saya setuju dengan syarat & ketentuan",
        confirm_btn: "Konfirmasi Pembayaran",
        order_summary: "Ringkasan Pesanan",
        checkin_sum: "Check-in",
        checkout_sum: "Check-out",
        guests_sum: "Tamu",
        guest_name: "Nama Tamu",
        total_payment: "Total Pembayaran",
        select_bank: "Pilih Bank",
        select_ewallet: "Pilih E-Wallet",
        close: "Tutup",

        // SUCCESS PAGE
        booking_confirmed: "Pemesanan Dikonfirmasi!",
        booking_confirmed_desc: "Terima kasih! Reservasi Anda berhasil dikirim.",
        booking_number: "Nomor Pemesanan",
        email_sent: "Email Terkirim",
        confirm_payment: "Konfirmasi Pembayaran",
        booking_details_title: "Detail Pemesanan",
        whats_next: "Langkah Selanjutnya?",
        next_1: "Kami akan verifikasi pembayaran dalam 1–2 jam",
        next_2: "Anda akan menerima email konfirmasi",
        next_3: "Tunjukkan voucher saat check-in",
        next_4: "Hubungi kami via WhatsApp jika ada pertanyaan",
        download_pdf: "Unduh PDF",
        back_home: "Kembali ke Beranda",
        need_help: "Butuh Bantuan?",
        guest_info: "Informasi Tamu",
        pending_verification: "Menunggu Verifikasi",

        // FOOTER
        footer_tagline: "Mitra terpercaya Anda untuk pemesanan villa dan homestay di Jogja.",
        footer_contact: "Hubungi Kami",
        footer_follow: "Ikuti Kami",
        footer_rights: "Hak cipta dilindungi.",
    },

    en: {
        // NAVBAR
        nav_home: "Home",
        nav_villas: "Villas",
        nav_contact: "Contact Us",

        // HERO / LANDINGPAGE
        hero_title: "Discover Your Perfect Villa",
        hero_subtitle: "Experience the beauty of Jogja with comfort and luxury",
        search_location: "Location",
        search_location_placeholder: "Enter location",
        search_checkin: "Check-in",
        search_checkout: "Check-out",
        search_guests: "Guests",
        search_beds: "Rooms",
        search_beds_all: "All",
        search_btn: "Search",

        // GUEST OPTIONS
        guest_2: "2 Guests",
        guest_3: "3 Guests",
        guest_4: "4 Guests",
        guest_5: "5 Guests",
        guest_6: "6 Guests",
        guest_7: "7 Guests",
        guest_8: "8 Guests",
        guest_9: "9 Guests",
        guest_10: "10 Guests",
        guest_11: "11 Guests",
        guest_12: "12 Guests",
        guest_13: "13 Guests",
        guest_14: "14 Guests",
        guest_15: "15 Guests",
        guest_15plus: "> 15 Guests",
        guest_20plus: "> 20 Guests",

        // STATS
        stat_villas: "Luxury Villas",
        stat_guests: "Happy Guests",
        stat_rating: "Average Rating",
        stat_support: "Support",

        // HOW IT WORKS
        how_title: "How It Works",
        how_subtitle: "Book your dream villa in just a few easy steps",
        how_step1_title: "Find a Villa",
        how_step1_desc: "Find a villa by location and number of guests",
        how_step2_title: "Choose Dates",
        how_step2_desc: "Set your check-in and check-out dates easily",
        how_step3_title: "Make Payment",
        how_step3_desc: "Secure payment with various methods",
        how_step4_title: "Enjoy Your Stay",
        how_step4_desc: "Check-in and enjoy the best hospitality experience",

        // WHY US
        why_title: "Why Choose JogjaVilla?",
        why_1_title: "Trusted & Secure",
        why_1_desc: "All our villas are verified and guaranteed safe for your stay",
        why_2_title: "Best Locations",
        why_2_desc: "Prime locations in Jogja with stunning views",
        why_3_title: "Easy Booking",
        why_3_desc: "Simple and fast booking process, confirmation in minutes",

        // FEATURED VILLAS
        featured_title: "Featured Villas",
        featured_subtitle: "Handpicked villas for your perfect vacation",
        view_all: "View All Villas",
        per_night: "per night",
        book_now: "Book Now",

        // TESTIMONIALS
        testimonial_title: "What They Say?",
        testimonial_sub: "Real experiences from our customers",

        // RECENTLY VIEWED
        recently_viewed: "Recently Viewed",
        clear_history: "Clear History",

        // CTA
        cta_title: "Ready to Start Your Journey?",
        cta_desc: "Browse our collection of beautiful villas and homestays in Jogja. Book now and create unforgettable memories!",
        cta_btn: "Explore All Villas",

        // VILLAS PAGE
        villas_hero_title: "Explore the Best Accommodations",
        villas_hero_sub: "Find your peace in every corner of Yogyakarta",
        villas_search_placeholder: "Search villa name or location...",
        filter_capacity: "Guest Capacity",
        filter_sort: "Sort: Best",
        sort_low: "Lowest Price",
        sort_high: "Highest Price",
        no_results_title: "Sorry, No Villas Found",
        no_results_desc: "Try changing your keywords or filters.",
        reset_filter: "Reset Filter",
        tamu: "Guests",
        bed: "Beds",
        bath: "Bathrooms",
        price_varies: "Price varies",
        check_price: "Check Price →",

        // VILLA DETAIL
        back_to_list: "Back to List",
        choose_room: "Choose Unit Variant",
        choose_room_desc: "Click one of the unit variants below to see specific details and check-out price:",
        no_rooms: "No additional room variants for this property.",
        selected_label: "🌟 (Selected)",
        capacity_title: "Accommodation Capacity",
        capacity_peserta: "Guest Capacity",
        capacity_kamar: "Number of Rooms",
        capacity_bed_type: "Room / Bed Type",
        bed_main: "Main bed size:",
        bathroom_title: "Bathroom Details",
        bathroom_count: "Number of Bathrooms",
        bathroom_type: "Bathroom Type",
        about_villa: "About This Villa",
        facilities_title: "Facilities & Services",
        facilities: "Facilities",
        equipment: "Equipment",
        amenities: "Amenities",
        hours_title: "Operational Hours / Rules",
        no_smoking: "🚭 No smoking inside",
        no_pets: "🐾 Pets not allowed",
        book_card_title: "Book Now",
        price_per_night: "/ night",
        btn_booking: "Continue Booking",
        btn_whatsapp: "Ask via WhatsApp",
        reviews: "reviews",

        // BOOKING PAGE
        back_booking: "← Back to Villa Details",
        booking_title: "Complete Your Booking",
        booking_details: "Booking Details",
        checkin_label: "Check-in",
        checkout_label: "Check-out",
        guests_label: "Guests",
        contact_info: "Contact Information",
        fullname_label: "Full Name",
        fullname_placeholder: "Full name",
        whatsapp_label: "WhatsApp Number",
        btn_continue: "Continue to Payment",
        processing: "Processing...",
        booking_summary: "Booking Summary",
        price_per_night_summary: "Price / Night",
        duration: "Duration",
        nights: "nights",
        total: "Total",

        // PAYMENT PAGE
        back_payment: "← Back to Booking",
        payment_title: "Payment",
        select_method: "Select Payment Method",
        select_type: "Select Payment Type",
        payment_instructions: "Payment Instructions",
        how_to_pay: "How to Pay:",
        step1: "Transfer the exact amount",
        step2: "Save your proof of payment",
        step3: "Click \"Confirm Payment\"",
        agree_terms: "I agree to the terms & conditions",
        confirm_btn: "Confirm Payment",
        order_summary: "Order Summary",
        checkin_sum: "Check-in",
        checkout_sum: "Check-out",
        guests_sum: "Guests",
        guest_name: "Guest Name",
        total_payment: "Total Payment",
        select_bank: "Select Bank",
        select_ewallet: "Select E-Wallet",
        close: "Close",

        // SUCCESS PAGE
        booking_confirmed: "Booking Confirmed!",
        booking_confirmed_desc: "Thank you! Your reservation has been successfully submitted.",
        booking_number: "Booking Number",
        email_sent: "Email Sent",
        confirm_payment: "Confirm Payment",
        booking_details_title: "Booking Details",
        whats_next: "What's Next?",
        next_1: "We will verify your payment within 1–2 hours",
        next_2: "You will receive a confirmation email",
        next_3: "Show your voucher at check-in",
        next_4: "Contact us via WhatsApp if you have any questions",
        download_pdf: "Download PDF",
        back_home: "Back to Home",
        need_help: "Need Help?",
        guest_info: "Guest Information",
        pending_verification: "Pending Verification",

        // FOOTER
        footer_tagline: "Your trusted partner for villa and homestay bookings in Jogja.",
        footer_contact: "Contact Us",
        footer_follow: "Follow Us",
        footer_rights: "All rights reserved.",
    }
};
